(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pagination"] && !Shopify.designMode) return;
  try {
    function initPaginate() {
    const paginate = document.getElementById('hb-js-paginate');
    const numButtons = paginate.querySelectorAll('[data-index]');

    if (numButtons.length <= 0) {
      return;
    }

    const centerIndex = Math.floor(numButtons.length / 2);

    if (centerIndex > 0) {
      switch (numButtons.length) {
        case 2:
          numButtons[centerIndex].classList.add('hb-add-current', 'hb-add-current--second');
          break;
        case 3:
          numButtons[centerIndex].classList.add('hb-add-current', 'hb-add-current--third');
          break;
        default:
          break;
      }
    }
  }

  initPaginate();
  } catch(e) { console.error(e); }
})();

})();
